import React from 'react'

export default () => <div style={{height: '100%', width: '100%'}} />
